import React, { ReactNode } from 'react';

export const DisclaimerContainer = ({ children }: { children: ReactNode }) => {
  return (
    <div className="whitespace-pre-line p-24 bg-slate-100 text-xs">
      {children}
    </div>
  );
};
